import axiosInstance from "../../../api/axiosInstance";

export const fetchMultiPurposeImagesAPI = async () => {
  const imagesList = await axiosInstance.get(
    "images/get-all-multi-purpose-images"
  );

  return imagesList.data;
};

export const uploadMultiPurposeImageAPI = async (imageData) => {
  const uploadedImage = await axiosInstance.post(
    "images/upload-multi-purpose-image",
    imageData
  );

  return uploadedImage.data;
};

export const deleteMultiPurposeImageAPI = async (id) => {
  const deleteImageId = await axiosInstance.delete(
    `images/delete-multi-purpose-image/${id}`
  );

  return deleteImageId.data;
};
